import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { API_BASE } from '../../utils/api';
import { Table, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

export default function AdminCustomers() {
    const [customers, setCustomers] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');

    useEffect(() => {
        fetchCustomers();
    }, []);

    const fetchCustomers = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('resido_token');
            const res = await fetch(`${API_BASE}/leads`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await res.json();
            // In a real system, we might have a separate customer model or unique leads
            if (res.ok) {
                setCustomers(Array.isArray(data) ? data : []);
            } else {
                setCustomers([]);
                toast.error(data.message || 'Failed to load customers');
            }
        } catch (err) {
            toast.error('Failed to load customers');
        } finally {
            setLoading(false);
        }
    };

    const filteredCustomers = customers.filter(c =>
        c.name.includes(search) ||
        c.mobile.includes(search)
    );

    return (
        <AdminLayout>
            <div className="card border-0 shadow-sm rounded-4">
                <div className="card-body p-4">
                    <div className="row mb-4 align-items-center">
                        <div className="col-md-6">
                            <h5 className="fw-bold mb-0 text-dark">Master Customer List</h5>
                            <p className="small text-muted mb-0">Total {customers.length} unique records managed</p>
                        </div>
                        <div className="col-md-6">
                            <div className="input-group">
                                <span className="input-group-text bg-light border-0"><i className="fa-solid fa-magnifying-glass text-muted"></i></span>
                                <Form.Control
                                    className="bg-light border-0 py-2"
                                    placeholder="Search by name or phone..."
                                    value={search}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Table hover borderless className="align-middle">
                            <thead className="bg-light">
                                <tr className="small fw-bold text-muted text-uppercase">
                                    <th className="ps-4">Name</th>
                                    <th>Mobile</th>
                                    <th>Email</th>
                                    <th>City</th>
                                    <th className="text-end pe-4">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan={5} className="text-center py-5"><div className="spinner-border text-primary" role="status"></div></td></tr>
                                ) : filteredCustomers.length === 0 ? (
                                    <tr><td colSpan={5} className="text-center py-5 text-muted">No customers found.</td></tr>
                                ) : filteredCustomers.map(c => (
                                    <tr key={c._id} className="border-bottom border-light">
                                        <td className="ps-4 fw-bold text-dark">{c.name}</td>
                                        <td>{c.mobile}</td>
                                        <td>{c.email || 'N/A'}</td>
                                        <td>{c.city || 'N/A'}</td>
                                        <td className="text-end pe-4">
                                            <Button variant="outline-dark" size="sm" className="rounded-pill px-3 fw-bold">View History</Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
}


